import { render, staticRenderFns } from "./SubscriptionInformationCard.vue?vue&type=template&id=20bc7b8a&"
import script from "./SubscriptionInformationCard.vue?vue&type=script&lang=js&"
export * from "./SubscriptionInformationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports